import React from 'react';
import { Star } from 'lucide-react';

type Props = {
  rating: number;
  maxStars?: number;
  size?: number;
  showValue?: boolean;
};

export default function StarRating({ rating, maxStars = 5, size = 14, showValue = false }: Props) {
  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: maxStars }, (_, i) => {
        const filled = i < Math.floor(rating);
        const partial = !filled && i < rating;
        return (
          <span key={`star-${i}`} className="relative inline-block" style={{ width: size, height: size }}>
            <Star
              size={size}
              className="star-empty absolute inset-0"
              fill="currentColor"
            />
            {(filled || partial) && (
              <span
                className="absolute inset-0 overflow-hidden"
                style={{ width: partial ? `${(rating % 1) * 100}%` : '100%' }}
              >
                <Star size={size} className="star-filled" fill="currentColor" />
              </span>
            )}
          </span>
        );
      })}
      {showValue && (
        <span className="text-sm font-semibold text-foreground ml-1 font-tabular">{rating.toFixed(1)}</span>
      )}
    </div>
  );
}